import { QueryClient } from 'react-query';

import { QUERY_CLIENT_DEFAULT_OPTIONS } from '@hotjar/api-base-client';

export const queryClient = new QueryClient({
  defaultOptions: QUERY_CLIENT_DEFAULT_OPTIONS,
});
